import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useImmer } from 'use-immer'
import React from 'react'
import _ from 'lodash'

import { Provider as ErrorsStateContextProvider } from '@/hooks/ErrorsStateContext'
import { Provider as InputStateContextProvider } from '@/hooks/inputStateContext'
import { actions, useDispatch } from '@/redux'
import { useMerchant } from '@/hooks/merchantContext'
import Dialog from '@/components/Dialog'
import MerchantSearch from '@/components/MerchantSearch'

const initialState = {
  source: '',
  target: '',
}

/**
 *
 * @param {*} props
 * @returns
 */
export default function CopyMenuDialog (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const [errors, setErrors] = React.useState({})
  const [merchantState, setMerchant] = useMerchant()
  const [inputState, setInputState] = useImmer({})
  const [source, setSource] = React.useState()
  const [target, setTarget] = React.useState()
  const updateInputState = (path, value) => {
    setInputState((draft) => {
      _.set(draft, path, value)
    })
  }

  // const validateInput = React.useCallback(() => {
  //   if (!merchantState) {
  //     return false
  //   }

  //   const temp = {}
  //   if (!_.isEmpty(temp)) {
  //     setErrors(temp)

  //     let message = ''
  //     if (_.size(temp) === 1) {
  //       message = _.map(temp, message => `* ${message}`)
  //     } else {
  //       message = _
  //         .chain(temp)
  //         .pickBy() // // pickBy() 預設使用 _.identity 來 pick，要注意的是這也會把 object 中任何 falsy value 給去掉，在這個情況是允許使用的，因為 temp 裡面只會有 string 或 undefined
  //         .map(message => `* ${message}`)
  //         .uniq() // 去除重複的錯誤訊息
  //         .join('\n')
  //         .value()
  //     }

  //     dispatch(actions.app.toggleDialog('alertDialog', true, {
  //       title: 'Error',
  //       content: message,
  //     }))

  //     return false
  //   } else {
  //     return true
  //   }
  // }, [inputState, merchantState])

  React.useEffect(() => {
    setInputState((draft) => {
      // 初始 inputState
      const newState = {
        ...initialState,
      }
      return newState
    })
  }, [merchantState.merchant])

  const open = merchantState.openCopyMenuDialog

  const handleClose = () => {
    setMerchant('merchant', {})
    setMerchant('openCopyMenuDialog', false)
    setErrors({})
  }

  const handleSubmit = async () => {
    try {
      await dispatch(actions.merchant.copyMenu(inputState))
      dispatch(actions.merchant.getMerchants())
    } catch (error) {
      dispatch(actions.app.toggleDialog('alertDialog', true, { title: 'Error', content: error.message }))
    } finally {
      handleClose()
    }
  }

  return (
    <InputStateContextProvider value={[inputState, updateInputState]}>
      <ErrorsStateContextProvider value={[errors, setErrors]}>
        <Dialog
          title='Copy Menu'
          open={open}
          handleClose={handleClose}
          renderActions={() => {
            return (
              <Button
                type='submit'
                variant='contained'
                color='primary'
                disableElevation
                onClick={handleSubmit}
              >
                COPY MENU
              </Button>
            )
          }}
        >
          <div className={classes.content}>
            Source
            <MerchantSearch
              onChange={(o) => {
                setSource(o)
                setInputState({ ...inputState, source: o?.id })
              }}
              value={source}
              onlyRemark={false}
            />
            Target
            <MerchantSearch
              onChange={(o) => {
                setTarget(o)
                setInputState({ ...inputState, target: o?.id })
              }}
              value={target}
              onlyRemark={false}
            />
          </div>
        </Dialog>
      </ErrorsStateContextProvider>
    </InputStateContextProvider>
  )
}

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    padding: 8,
    gap: 8,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 400,
    padding: 16,
  },
}))
